export var TabButtonCssClass;
(function (TabButtonCssClass) {
    TabButtonCssClass["Base"] = "iress-tab-button";
    TabButtonCssClass["Active"] = "iress-tab-button--active";
    TabButtonCssClass["Button"] = "iress-tab-button__button";
    TabButtonCssClass["Focus"] = "iress-tab-button__button--focus";
    TabButtonCssClass["VrtFocus"] = "iress-tab-button--vrt-focus";
    TabButtonCssClass["VrtHover"] = "iress-tab-button--vrt-hover";
})(TabButtonCssClass || (TabButtonCssClass = {}));
//# sourceMappingURL=tab-button.types.js.map